




import { Component, Prop, Watch, Vue} from 'division-marker';
import {Searcher, SaitenState} from 'saiten-base'

@Component({components: {Searcher}, mixins:[]})
export default class Users extends Vue {
  // @Prop() private msg!: string;
  // get state():SaitenState{return this.$store.state.saiten;}
  // mounted(){    
  // }
}
